import { React, useState, useEffect } from "react";
import {
  Button,
  Form,
  Input,
  Select,
  Col,
  Row,
  Checkbox,
  Tooltip,
  Radio,
  Dropdown,
  Menu,
  Switch,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import {
  getReelCoreValues,
  addReelCoreValues,
  updateCoreValue,
  updateReelValue,
  deleteCoreValue,
  deleteReelValue,
} from "../../../Services/settingsServices";
import styled from "styled-components";
import { GlobalSet, Styled } from "../../pageStyled";
import warning from "../../../Assets/Icons/warning.png";
import trusted from "../../../Assets/Icons/trusted.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import { getUnitData } from "../../../Services/measurementService";
import { weightUnit } from "../../../Utils/Constant/MeasurementUnitList";

const { Option } = Select;
const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

const ReelOrderSpecDrawer = (props) => {
  const [coreForm] = Form.useForm();
  const [reelForm] = Form.useForm();
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const coreUnitData = ["mm", "cm"];
  const reelUnitData = ["mm", "cm"];
  const [reelAction, setReelAction] = useState("add");
  const [coreAction, setCoreAction] = useState("add");
  const [saveType, setSaveType] = useState();
  const [selectedCoreDia, setSelectedCoreDia] = useState();
  const [selectedReelDia, setSelectedReelDia] = useState();
  const [isCoreDefault, setIsCoreDefault] = useState(false);
  const [isReelDefault, setIsReelDefault] = useState(false);
  const [data, setData] = useState();
  const [rendering, setRendering] = useState(true);
  const [alert, setAlert] = useState(false);
  const [response, setResponse] = useState();
  const [deleteCoreModal, setDeleteCoreModal] = useState(false);
  const [deleteReelModal, setDeleteReelModal] = useState(false);
  const userDetails =JSON.parse(localStorage.getItem("user-details"));
  const [measurementData, setMeasurementData] = useState();
  useEffect(() => {
    if (rendering) {
      (async () => {
        try {
          const response = await getReelCoreValues();
          if (!response.error) {
            setData(response);
          }
        } catch (error) {
          console.log(error);
        }

        try{
          const unitData = await getUnitData();
          if(!unitData.error){
            setMeasurementData(unitData);
          }
        } catch(err){
          console.log(err);
        }
      })();
      setRendering(false);
    }
  }, [rendering]);

  const onReelDiaSave = () => {
    reelForm.submit();
  };

  const onCoreDiaSave = () => {
    coreForm.submit();
  };

  const onEditReelDia = (e, index) => {
    setSelectedReelDia(data.reel_data[index]);
    setReelAction("edit");
    setIsReelDefault((data.default_reel_od === data.reel_data[index][0]) && (data.default_reel_unit?.toUpperCase() === data.reel_data[index][1]?.toUpperCase()));
    reelForm.setFieldsValue({
      reelDia: data.reel_data[index][0],
      isReelDefaultc: data.default_reel_od === data.reel_data[index][0],
      reelUnit: data.reel_data[index][1]
    });
  };

  const onEditCoreDia = (e, index) => {
    setSelectedCoreDia(data.core_data[index]);
    setIsCoreDefault((data.default_core_id === data.core_data[index][0]) && (data.default_core_unit?.toUpperCase() === data.core_data[index][1]?.toUpperCase()));
    setCoreAction("edit");
    coreForm.setFieldsValue({
      coreDia: data.core_data[index][0],
      isCoreDefault: data.default_core_id === data.core_data[index][0],
      coreUnit: data.core_data[index][1],
      coreDiaLength : data.core_data_details[index].core_length.value,
      coreLengthUnit : data.core_data_details[index].core_length.units,
      coreDiaWeight : data.core_data_details[index].core_weight.value,
      coreWeightUnit : data.core_data_details[index].core_weight.units
    });
  };

  const onAddReelDia = () => {
    setReelAction("add");
    reelForm.resetFields();
    reelForm.setFieldsValue({reelUnit: measurementData.data.units_management.length.default});
    setIsReelDefault(false);
  };

  const onAddCoreDia = () => {
    setCoreAction("add");
    coreForm.resetFields();
    coreForm.setFieldsValue({coreUnit: measurementData.data.units_management.length.default,
      coreLengthUnit: measurementData.data.units_management.length.default,
      coreWeightUnit: measurementData.data.units_management.weight.default});
    setIsCoreDefault(false);
  };

  const onCoreFinish = async (e) => {
    let req = {
      core_id: parseFloat(e.coreDia),
      units:
      { core_id : e.coreUnit,
        core_weight : e.coreWeightUnit,
        core_length : e.coreLengthUnit
      },
      default: isCoreDefault,
      core_weight : parseFloat(e.coreDiaWeight),
      core_length : parseFloat(e.coreDiaLength),
    };

    if (coreAction === "add") {
      try {
        const resp = await addReelCoreValues(req);
        if (!resp.error) {
          setResponse(resp);
          setAlert(true);
          setTimeout(() => {
            setAlert(false);
          }, 3000);
        }
      } catch (error) {
        console.log(error);
        setAlert(true);
        if(error?.response?.status == 500){
          setResponse("Something went wrong. Please try again");
        } else{
          setResponse(error.response.data);
        }
        setTimeout(() => {
        setAlert(false);
        }, 3000);
      }
    } else {
      try {
        const resp = await updateCoreValue(req, selectedCoreDia[0], selectedCoreDia[1]);
        if (!resp.error) {
          setResponse(resp);
          setAlert(true);
          setTimeout(() => {
            setAlert(false);
          }, 3000);
        }
      } catch (error) {
        console.log(error);
        setAlert(true);
        if(error?.response?.status == 500){
          setResponse("Something went wrong. Please try again");
        } else{
          setResponse(error.response.data?.msg);
        }
        setTimeout(() => {
        setAlert(false);
        }, 3000);
      }
    }
    setCoreAction("add");
    coreForm.resetFields();
    setIsCoreDefault(false);
    setSelectedCoreDia("");
    setRendering(true);
  };

  const onReelFinish = async (e) => {
    // console.log(e);

    let req = {
      reel_od: parseFloat(e.reelDia),
      units:
      {
        reel_od: e.reelUnit,
      },
      default: isReelDefault,
    };

    if (reelAction === "add") {
      try {
        const resp = await addReelCoreValues(req);
        if (!resp.error) {
          setResponse(resp);
          setAlert(true);
          setTimeout(() => {
            setAlert(false);
          }, 3000);
        }
      } catch (error) {
        console.log(error);
        setAlert(true);
        if(error?.response?.status == 500){
          setResponse("Something went wrong. Please try again");
        } else{
          setResponse(error.response.data);
        }
        setTimeout(() => {
        setAlert(false);
        }, 3000);
      }
    } else {
      try {
        const resp = await updateReelValue(req,  selectedReelDia[0], selectedReelDia[1]);
        if (!resp.error) {
          setResponse(resp);
          setAlert(true);
          setTimeout(() => {
            setAlert(false);
          }, 3000);
        }
      } catch (error) {
        console.log(error);
        setAlert(true);
        if(error?.response?.status == 500){
          setResponse("Something went wrong. Please try again");
        } else{
          setResponse(error.response.data);
        }
        setTimeout(() => {
        setAlert(false);
        }, 3000);
      }
    }

    setReelAction("add");
    reelForm.resetFields();
    setIsReelDefault(false);
    setSelectedReelDia("");
    setRendering(true);
  };

  const onCoreDefaultChange = (event) => {
    setIsCoreDefault(event.target.checked);
  };

  const onReelDefaultChange = (event) => {
    setIsReelDefault(event.target.checked);
  };

  const onDeleteCoreDia = (index) => {
    setSelectedCoreDia(data.core_data[index]);
    setDeleteCoreModal(true);
    coreForm.setFieldsValue({coreUnit: measurementData.data.units_management.length.default});
  };

  const onDeleteReelDia = (index) => {
    setSelectedReelDia(data.reel_data[index]);
    setDeleteReelModal(true);
    reelForm.setFieldsValue({reelUnit: measurementData.data.units_management.length.default});
  };

  const deleteCoreModalConfirm = async () => {
    setReelAction("add");
    reelForm.resetFields();
    setIsReelDefault(false);
    setCoreAction("add");
    coreForm.resetFields();
    setIsCoreDefault(false);
    setDeleteCoreModal(false);
    try {
      const resp = await deleteCoreValue(parseFloat( selectedCoreDia[0] ), selectedCoreDia[1]);
      if (!resp.error) {
        console.log(resp);
        setResponse(resp);
        setAlert(true);
        setTimeout(() => {
          setAlert(false);
        }, 3000);
      }
    } catch (error) {
        console.log(error);
        setAlert(true);
        if(error?.response?.status == 500){
          setResponse("Something went wrong. Please try again");
        } else{
          setResponse(error.response.data);
        }
        setTimeout(() => {
        setAlert(false);
        }, 3000);
    }
    setRendering(true);
  };

  const cancelCoreModal = () => {
    setDeleteCoreModal(false);
  };

  const deleteReelModalConfirm = async () => {
    setReelAction("add");
    reelForm.resetFields();
    setIsReelDefault(false);
    setCoreAction("add");
    coreForm.resetFields();
    setIsCoreDefault(false);
    setDeleteReelModal(false);
    try {
      const resp = await deleteReelValue(parseFloat(selectedReelDia[0]), selectedReelDia[1]);
      if (!resp.error) {
        console.log(resp);
        setResponse(resp);
        setAlert(true);
        setTimeout(() => {
          setAlert(false);
        }, 3000);
      }
    } catch (error) {
      console.log(error);
        setAlert(true);
        if(error?.response?.status == 500){
          setResponse("Something went wrong. Please try again");
        } else{
          setResponse(error.response.data);
        }
        setTimeout(() => {
        setAlert(false);
        }, 3000);
    }
    setRendering(true);
  };

  const cancelReelModal = () => {
    setDeleteReelModal(false);
  };

  const onClose = () => {
    setReelAction("add");
    reelForm.resetFields();
    setIsReelDefault(false);
    setCoreAction("add");
    coreForm.resetFields();
    setIsCoreDefault(false);
    setSelectedCoreDia("");
    setSelectedReelDia("");
    props.onClose();
    setMeasurementData();
  };

  return data && measurementData ? (
    <RightDrawerSidebar
      title="Reel Order Specifications"
      subtitle=""
      visible={props.visible}
      onClose={onClose}
    >
      {alert && (
        <AlertContainer
          color={response?.error ? "red" : "green"}
          icon={response?.error ? alertRed : alertGreen}
          msg={response?.msg}
        />
      )}
      <RightDrawerContainer>
        <HaberForm>
          <Form
            form={coreForm}
            name="basic"
            autoComplete="off"
            className="haberLogin haberSignup"
            style={{ marginTop: "0" }}
            onFinish={onCoreFinish}
          >
            <div
              className="drawerField titleWithText"
              style={{ paddingTop: "0" }}
            >
              <h5>Core Outer Diameter</h5>
              <p>
                The outer diameter of the core during rewinding
              </p>
              <GlobalSet
                style={{ textAlign: "left", marginTop: "16px" }}
                //onClick={toggleClass}
              >
                {coreAction === "edit" && (
                  <Button
                    className="textTypeBtn textBtnIcon"
                    style={{ marginLeft: "0" }}
                    onClick={onAddCoreDia}
                     disabled={!userDetails.roles.global_settings.edit}
                  >
                    <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                    Add a new core dia
                  </Button>
                )}
              </GlobalSet>
              <div
                className="titleWithText dFlex"
                style={{ justifyContent: "space-between", margin: "10px 0" }}
              >
                <h6 style={{ alignSelf: "center" }}>
                  {" "}
                  {coreAction === "add"
                    ? " Add a core diameter"
                    : "Edit a core diameter"}
                </h6>
                {userDetails.roles.global_settings.edit && (<GlobalSet
                  className="specialBtn adjCntBtn"
                  style={{ width: "calc(100% - 125px)" }}
                >
                  <Styled styled={{ display: "flex" }}>
                    <Tooltip
                      placement="bottomRight"
                      title={"Cancel Diameter"}
                      className="edit-tooltip"
                      getPopupContainer={(triggerNode) => triggerNode}
                    >
                      <Button
                        className="textTypeBtn noMargin blackTxt"
                        onClick={onAddCoreDia}
                        disabled={!userDetails.roles.global_settings.edit}
                      >
                        Cancel
                      </Button>
                    </Tooltip>
                  </Styled>
                  <Styled styled={{ display: "flex" }}>
                    <Tooltip
                      placement="bottomRight"
                      title={"Save Diameter"}
                      className="edit-tooltip"
                      getPopupContainer={(triggerNode) => triggerNode}
                    >
                      {" "}
                      <Button
                        className="textTypeBtn textBtnIcon"
                        onClick={onCoreDiaSave}
                        disabled={!userDetails.roles.global_settings.edit}
                      >
                        <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                        Save
                      </Button>
                    </Tooltip>
                  </Styled>
                </GlobalSet>)}
              </div>
              <Col span={24}>
                <Row className="centerAlign justifyCSBetween">
                  <Col span={16}>
                    <div className="boxFormType" style={{ marginBottom: "0" }}>
                      <Form.Item
                        name="coreDia"
                        rules={[
                          {
                            required: true,
                            message: " This field is mandatory",
                          },
                          {
                            pattern: new RegExp(/^\d+(\.\d{0,6})?$/),
                            message: "Upto 6 decimal point values is accepted",
                          },
                          {
                            pattern: new RegExp(
                              /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                            ),
                            message: "Diameter should be a number greater than zero",
                          },
                        ]}
                        className="dBlock"
                        // initialValue={
                        //   coreAction === "edit" ? selectedCoreDia.value : ""
                        // }
                      >
                        <Input placeholder="Enter Core Dia"
                        disabled={!userDetails.roles.global_settings.edit} />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={7}>
                    <div
                      className="boxFormType unitSelect"
                      style={{ marginBottom: "0" }}
                    >
                      <Form.Item
                        name="coreUnit"
                        rules={[{ required: true }]}
                        className="dBlock"
                        initialValue={coreAction === "add" && measurementData.data.units_management.length.default}
                      >
                        <Select
                          disabled={!userDetails.roles.global_settings.edit}
                          placeholder="Unit"
                          suffixIcon={<DownArrowDraw />}
                        >
                          {measurementData.data.units_management.length.data.map((unit) => (
                            <Option key={unit} value={unit}>
                              {unit}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
               
              </Col>
              <h6 style={{ alignSelf: "center" }}>
                  {" "}
                  {coreAction === "add"
                    ? " Add  core weight"
                    : "Edit  core weight"}
                </h6>
              <Col span={24}>
                <Row className="centerAlign justifyCSBetween removeStar">
                  <Col span={16}>
                    <div className="boxFormType" style={{ marginBottom: "0" }}>
                      <Form.Item
                      label="Per Length"
                        name="coreDiaLength"
                        rules={[
                          {
                            required: true,
                            message: " This field is mandatory",
                          },
                          {
                            pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                            message: "Upto 3 decimal point values is accepted",
                          },
                          {
                            pattern: new RegExp(
                              /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                            ),
                            message: "Length should be a number greater than zero",
                          },
                        ]}
                        className="dBlock"
                        // initialValue={
                        //   coreAction === "edit" ? selectedCoreDia.value : ""
                        // }
                      >
                        <Input placeholder="Enter Value"
                        disabled={!userDetails.roles.global_settings.edit} />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={7}>
                    <div
                      className="boxFormType unitSelect "
                      style={{ marginBottom: "0" }} 
                    >
                      <Form.Item
                        name="coreLengthUnit"
                        label="Unit"
                        rules={[{ required: true }]}
                        className="dBlock"
                        initialValue={coreAction === "add" && measurementData.data.units_management.length.default}
                      >
                        <Select
                          disabled={!userDetails.roles.global_settings.edit}
                          placeholder="Unit"
                          suffixIcon={<DownArrowDraw />}
                        >
                          {measurementData.data.units_management.length.data.map((unit) => (
                            <Option key={unit} value={unit}>
                              {unit}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                
              </Col>
              <Col span={24}>
                <Row className="centerAlign justifyCSBetween removeStar">
                  <Col span={16}>
                    <div className="boxFormType" style={{ marginBottom: "0" }}>
                      <Form.Item
                      label="Weight"
                        name="coreDiaWeight"
                        rules={[
                          {
                            required: true,
                            message: " This field is mandatory",
                          },
                          {
                            pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                            message: "Upto 3 decimal point values is accepted",
                          },
                          {
                            pattern: new RegExp(
                              /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                            ),
                            message: "Weight should be a number greater than zero",
                          },
                        ]}
                        className="dBlock"
                        // initialValue={
                        //   coreAction === "edit" ? selectedCoreDia.value : ""
                        // }
                      >
                        <Input placeholder="Enter Value"
                        disabled={!userDetails.roles.global_settings.edit} />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={7}>
                    <div
                      className="boxFormType unitSelect "
                      style={{ marginBottom: "0" }} 
                    >
                      <Form.Item
                        name="coreWeightUnit"
                        label="Unit"
                        rules={[{ required: true }]}
                        className="dBlock"
                        initialValue={coreAction === "add" && measurementData.data.units_management.weight.default}
                      >
                        <Select
                          disabled={!userDetails.roles.global_settings.edit}
                          placeholder="Unit"
                          suffixIcon={<DownArrowDraw />}
                        >
                          {measurementData.data.units_management.weight.data.map((unit) => (
                            <Option key={unit} value={unit}>
                              {weightUnit[unit].displayName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Row
                  className="centerAlign justifyCSBetween"
                  style={{ marginTop: "-8px", marginBottom: "-16px" }}
                >
                  <Col>
                    <Form.Item
                      name="isCoreDefault"
                      className="dBlock"
                      valuePropName="checked"
                      initialValue={false}
                    >
                      <Checkbox
                        checked={isCoreDefault}
                        name="isCoreDefault"
                        onChange={onCoreDefaultChange}
                        disabled={!userDetails.roles.global_settings.edit}
                      ></Checkbox>
                      <span
                        style={{
                          marginLeft: "5px",
                          fontSize: "14px",
                          fontWeight: "500",
                          fontSize: "14px",
                          fontFamily: "var(--sf-pro-text)",
                          color: "var(--color-text-title)",
                          lineHeight: "20px",
                        }}
                      >
                        Set it as default core dia
                      </span>
                    </Form.Item>
                  </Col>
                </Row>
                <Row
                  className="centerAlign justifyCSBetween"
                  style={{ marginBottom: "12px" }}
                >
                  <Col>
                    <p className="qualityInfo It">
                      You can set it as default core diameter if all orders are
                      produced with same core diameter
                    </p>
                  </Col>
                </Row>
              </Col>
            </div>
            <DetailFields>
              <div className="groupDetailWrap qualityRow">
                <Row gutter={[24, 24]} className="groupForm">
                  <Col span={24}>
                    {data.core_data?.map((core, index) => {
                      // console.log('quality', quality)
                      return (
                        <>
                        <Row className="centerAlign" >
                          <Row style={{width:'100%'}} >
                          <Col span={18}>
                            <div className="boxFieldTitle">
                              <label>
                                {" "}
                                {core[0]} {""} {core[1]?.toUpperCase()}{" "}
                                {((core[0] === data.default_core_id) && (core[1]?.toUpperCase() === data.default_core_unit?.toUpperCase()))&& (
                                  <span
                                    style={{
                                      fontSize: "11px",
                                      fontFamily: "var(--sf-pro-display-m)",
                                      color: "var(--para-text)",
                                      lineHeight: "16px",
                                      backgroundColor: "#edebe9",
                                      borderRadius: "10px",
                                      padding: "1px 8px",
                                      marginLeft: "4px",
                                      fontStyle: "unset",
                                    }}
                                  >
                                    {" "}
                                    DEFAULT{" "}
                                  </span>
                                )}{" "}
                              </label>
                            </div>
                          </Col>
                          <Col span={6}>
                            <div className="boxFormType">
                             {userDetails.roles.global_settings.edit && ( <GlobalSet>
                                <Styled
                                  className="dFlex centerAlignBtn"
                                  style={{ paddingLeft: "5px" }}
                                >
                                  <Tooltip
                                    placement="bottomRight"
                                    title={"Edit Diameter"}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode
                                    }
                                  >
                                    <Button
                                      // onClick={() =>
                                      //   handleDeleteQuality(quality)
                                      // }
                                      // disabled={index === 0}
                                      disabled={!userDetails.roles.global_settings.edit}
                                      onClick={(e) => {
                                        onEditCoreDia(e, index);
                                      }}
                                      className="textTypeBtn edit-btn edit-tooltip deleteQtyBtn"
                                    >
                                      <Iconmoon
                                        icon="edit"
                                        size={17}
                                        color="#605E5C"
                                      />
                                    </Button>
                                  </Tooltip>
                                  <Tooltip
                                    placement="bottomRight"
                                    title={"Delete Diameter"}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode
                                    }
                                  >
                                    <Button
                                      onClick={() => onDeleteCoreDia(index)}
                                      // disabled={index === 0}
                                      disabled={!userDetails.roles.global_settings.edit}
                                      className="textTypeBtn edit-btn edit-tooltip deleteQtyBtn"
                                    >
                                      <Iconmoon
                                        icon="delete"
                                        size={17}
                                        color="#605E5C"
                                      />
                                    </Button>
                                  </Tooltip>
                                </Styled>
                              </GlobalSet>
                              )}
                            </div>
                          </Col>
                          </Row>
                          <Row className="centerAlign" style={{paddingTop:'0px',paddingBottom:'0px'}}>
                        <Col span={24} style={{fontSize:'12px'}}>
                          Weight: {data.core_data_details[index].core_weight.value + ' ' + capitalize(weightUnit[data.core_data_details[index].core_weight.units].displayName) + ' Per ' + data.core_data_details[index].core_length.value + ' ' +  data.core_data_details[index].core_length.units.toUpperCase()}
                          </Col>
                          </Row>
                        </Row>
                        
                          </>
                      );
                    })}
                  </Col>
                </Row>
              </div>
            </DetailFields>
          </Form>
        </HaberForm>
        <HaberForm>
          <Form
            form={reelForm}
            name="basic"
            autoComplete="off"
            className="haberLogin haberSignup"
            style={{ marginTop: "0" }}
            onFinish={onReelFinish}
          >
            <div className="drawerField titleWithText" style={{padding : "0px 0px"}}>
              <h5>Reel Outer Diameter</h5>
              <p>The outer diameter of the reels during rewinding</p>
              <GlobalSet
                style={{ textAlign: "left", marginTop: "16px" }}
                //onClick={toggleClass}
              >
                {reelAction === "edit" && (
                  <Button
                    className="textTypeBtn textBtnIcon"
                    style={{ marginLeft: "0" }}
                    onClick={onAddReelDia}
                    disabled={!userDetails.roles.global_settings.edit}
                    // disabled={!userDetails.roles.global_settings.edit}
                  >
                    <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                    Add a new reel dia
                  </Button>
                )}
              </GlobalSet>
              <div
                className="titleWithText dFlex"
                style={{ justifyContent: "space-between", margin: "10px 0" }}
              >
                <h6 style={{ alignSelf: "center" }}>
                  {reelAction === "add"
                    ? "Add a reel diameter"
                    : "Edit a reel diameter"}{" "}
                </h6>
               {userDetails.roles.global_settings.edit && ( <GlobalSet
                  className="specialBtn adjCntBtn"
                  style={{ width: "calc(100% - 125px)" }}
                >
                  <Styled styled={{ display: "flex" }}>
                    <Tooltip
                      placement="bottomRight"
                      title={"Cancel Diameter"}
                      className="edit-tooltip"
                      getPopupContainer={(triggerNode) => triggerNode}
                    >
                      <Button
                        className="textTypeBtn noMargin blackTxt"
                        onClick={onAddReelDia}
                        disabled={!userDetails.roles.global_settings.edit}
                      >
                        Cancel
                      </Button>
                    </Tooltip>
                  </Styled>
                  <Styled styled={{ display: "flex" }}>
                    <Tooltip
                      placement="bottomRight"
                      title={"Save Diameter"}
                      className="edit-tooltip"
                      getPopupContainer={(triggerNode) => triggerNode}
                    >
                      {" "}
                      <Button
                        className="textTypeBtn textBtnIcon"
                        onClick={onReelDiaSave}
                        disabled={!userDetails.roles.global_settings.edit}
                      >
                        <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                        Save
                      </Button>
                    </Tooltip>
                  </Styled>
                </GlobalSet>)}
              </div>
              <Col span={24}>
                <Row className="centerAlign justifyCSBetween">
                  <Col span={16}>
                    <div className="boxFormType" style={{ marginBottom: "0" }}>
                      <Form.Item
                        name="reelDia"
                        rules={[
                          {
                            required: true,
                            message: "This field is mandatory",
                          },
                          {
                            pattern: new RegExp(/^\d+(\.\d{0,6})?$/),
                            message: "Upto 6 decimal point values is accepted",
                          },
                          {
                            pattern: new RegExp(
                              /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                            ),
                            message: "Diameter should be a number greater than zero",
                          },
                        ]}
                        className="dBlock"
                        // initialValue={
                        //   reelAction === "edit" ? selectedReelDia.value : ""
                        // }
                      >
                        <Input placeholder="Enter Reel Dia"
                        disabled={!userDetails.roles.global_settings.edit} />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={7}>
                    <div
                      className="boxFormType unitSelect"
                      style={{ marginBottom: "0" }}
                    >
                      <Form.Item
                        name="reelUnit"
                        rules={[{ required: true }]}
                        className="dBlock"
                        initialValue={reelAction === "add" && measurementData.data.units_management.length.default}
                      >
                        <Select
                          placeholder="Unit"
                          suffixIcon={<DownArrowDraw />}  
                          disabled={!userDetails.roles.global_settings.edit}>
                          {measurementData.data.units_management.length.data.map((unit) => (
                            <Option key={unit} value={unit}>
                              {unit}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Row
                  className="centerAlign justifyCSBetween"
                  style={{ marginTop: "-8px", marginBottom: "-16px" }}
                >
                  <Col>
                    <Form.Item
                      name="isReelDefault"
                      className="dBlock"
                      initialValue=""
                      valuePropName="checked"
                    >
                      <Checkbox
                        onChange={onReelDefaultChange}
                        checked={isReelDefault}
                        disabled={!userDetails.roles.global_settings.edit}
                      ></Checkbox>
                      <span
                        style={{
                          marginLeft: "5px",
                          fontSize: "14px",
                          fontWeight: "500",
                          fontSize: "14px",
                          fontFamily: "var(--sf-pro-text)",
                          color: "var(--color-text-title)",
                          lineHeight: "20px",
                        }}
                      >
                        Set it as default reel dia
                      </span>
                    </Form.Item>
                  </Col>
                </Row>
                <Row
                  className="centerAlign justifyCSBetween"
                  style={{ marginBottom: "12px" }}
                >
                  <Col>
                    <p className="qualityInfo It">
                      You can set it as default reel diameter if all orders are
                      produced with same reel diameter
                    </p>
                  </Col>
                </Row>
              </Col>
            </div>
            <DetailFields>
              <div className="groupDetailWrap qualityRow">
                <Row gutter={[24, 24]} className="groupForm">
                  <Col span={24}>
                    {data.reel_data?.map((reel, index) => {
                      // console.log('quality', quality)
                      return (
                        <Row className="centerAlign">
                          <Col span={18}>
                            <div className="boxFieldTitle">
                              <label>
                                {" "}
                                {reel[0]} {""} {reel[1]?.toUpperCase()}{" "}
                                {((reel[0] === data.default_reel_od) && (reel[1]?.toUpperCase() === data.default_reel_unit?.toUpperCase())) && (
                                  <span
                                    style={{
                                      fontSize: "11px",
                                      fontFamily: "var(--sf-pro-display-m)",
                                      color: "var(--para-text)",
                                      lineHeight: "16px",
                                      backgroundColor: "#edebe9",
                                      borderRadius: "10px",
                                      padding: "1px 8px",
                                      marginLeft: "4px",
                                      fontStyle: "unset",
                                    }}
                                  >
                                    {" "}
                                    DEFAULT{" "}
                                  </span>
                                )}{" "}
                              </label>
                            </div>
                          </Col>
                          { userDetails.roles.global_settings.edit && (<Col span={6}>
                            <div className="boxFormType">
                              <GlobalSet>
                                <Styled
                                  className="dFlex centerAlignBtn"
                                  style={{ paddingLeft: "5px" }}
                                >
                                  <Tooltip
                                    placement="bottomRight"
                                    title={"Edit Diameter"}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode
                                    }
                                  >
                                    <Button
                                      // onClick={() =>
                                      //   handleDeleteQuality(quality)
                                      // }
                                      // disabled={index === 0}
                                      disabled={!userDetails.roles.global_settings.edit}
                                      onClick={(e) => {
                                        onEditReelDia(e, index);
                                      }}
                                      className="textTypeBtn edit-btn edit-tooltip deleteQtyBtn"
                                    >
                                      <Iconmoon
                                        icon="edit"
                                        size={17}
                                        color="#605E5C"
                                      />
                                    </Button>
                                  </Tooltip>
                                  <Tooltip
                                    placement="bottomRight"
                                    title={"Delete Diameter"}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode
                                    }
                                  >
                                    <Button
                                    style={{background : 'none'}}
                                      onClick={() => onDeleteReelDia(index)}
                                      disabled={!userDetails.roles.global_settings.edit}
                                      // disabled={index === 0}

                                      className="textTypeBtn edit-btn edit-tooltip deleteQtyBtn"
                                    >
                                      <Iconmoon
                                        icon="delete"
                                        size={17}
                                        color="#605E5C"
                                      />
                                    </Button>
                                  </Tooltip>
                                </Styled>
                              </GlobalSet>
                            </div>
                          </Col>)}
                        </Row>
                      );
                    })}
                  </Col>
                </Row>
              </div>
            </DetailFields>
          </Form>
        </HaberForm>
      </RightDrawerContainer>
      <ModalPopup visible={deleteCoreModal}>
        <div className="Popup-img">
          <img src={warning} />
        </div>
        <div className="Popup-content">
          <span>Delete Core Dia?</span>
          <p>
            You will not be able to recover this core dia once deleted. Are you
            sure you want to continue?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => cancelCoreModal()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn btn"
            onClick={() => deleteCoreModalConfirm()}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>
      <ModalPopup visible={deleteReelModal}>
        <div className="Popup-img">
          <img src={warning} />
        </div>
        <div className="Popup-content">
          <span>Delete Reel Dia?</span>
          <p>
            You will not be able to recover this reel dia once deleted. Are you
            sure you want to continue?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => cancelReelModal()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => deleteReelModalConfirm()}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>
    </RightDrawerSidebar>
  ) : null;
};

export default ReelOrderSpecDrawer;
